var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.backgroundImageUrl,"alt":_vm.slide.name}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }